/* ============================================================
   TAIBI — NASTRO DEI MARCHI
   Fa una cosa sola: scrive la durata dell'animazione dividendo la
   larghezza misurata della serie per la velocità scelta nel customizer.

   ⚠️ Perché non basta un tempo fisso nello schema: la serie si allunga a
   ogni marchio aggiunto, quindi lo stesso numero di secondi diventa una
   velocità diversa. Il customizer espone i PIXEL AL SECONDO, che è la
   cosa che si vuole tenere ferma, e i secondi si ricavano qui.

   ⚠️ La serie include già il suo stacco a destra (`padding-right` nel
   CSS): è esattamente la distanza che `translateX(-50%)` percorre.
   Misurare l'elemento e dividere è quindi corretto senza correzioni.

   Nessun comando di pausa: deciso il 19 agosto 2026. L'unica cosa che
   spegne il nastro è `prefers-reduced-motion`, e sta nel CSS.
   ============================================================ */
(function () {
  'use strict';

  function taraNastro(nastro) {
    var pista = nastro.querySelector('.marchi__pista');
    var serie = nastro.querySelector('.marchi__serie');
    if (!pista || !serie) return;

    var passo = parseFloat(nastro.getAttribute('data-marchi-velocita')) || 46;
    var largo = serie.getBoundingClientRect().width;
    /* A larghezza zero il font non è ancora arrivato o la sezione è
       nascosta: scrivere una durata adesso la fisserebbe sbagliata. */
    if (!largo) return;

    pista.style.setProperty('--marchi-durata', (largo / passo).toFixed(2) + 's');
  }

  function tara(radice) {
    var nastri = (radice || document).querySelectorAll('[data-marchi-velocita]');
    for (var i = 0; i < nastri.length; i++) taraNastro(nastri[i]);
  }

  /* ⚠️ I loghi sono `loading="lazy"` e arrivano dopo. Con `width`/`height`
     sull'immagine il posto e' gia' riservato e la larghezza non cambia al
     caricamento — misurato: cella 34px sia prima sia dopo. Ma se un giorno
     un'immagine finisse senza quegli attributi, la serie si allargherebbe
     DOPO il calcolo della durata e la velocita' resterebbe sbagliata in
     silenzio. Ricalcolare al `load` costa niente e chiude il caso. */
  function guardaLeImmagini(nastro) {
    var img = nastro.querySelectorAll('img');
    for (var i = 0; i < img.length; i++) {
      if (img[i].complete) continue;
      img[i].addEventListener('load', function () { taraNastro(nastro); });
    }
  }

  function avvia() {
    tara();
    var nastri = document.querySelectorAll('[data-marchi-velocita]');
    for (var i = 0; i < nastri.length; i++) guardaLeImmagini(nastri[i]);
    /* Il carattere del tema arriva dopo il primo calcolo e cambia la
       larghezza della serie: senza questo secondo giro la velocità
       resterebbe tarata sul carattere di ripiego. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { tara(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  window.addEventListener('resize', function () { tara(); });

  /* ⚠️ Nell'editor del tema Shopify rimonta il markup senza ricaricare la
     pagina: senza questi due la sezione appena aggiunta o riordinata
     resterebbe con la durata di ripiego del CSS. */
  document.addEventListener('shopify:section:load', function (e) {
    tara(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    tara(e.target);
  });
})();
